<template>
  <div class="common_group">
    <div class="title">
      <img src="@/assets/images/informationIcon.png">
      <!-- ei: '活动信息', -->
      <span>{{ $t('newApp.activityInfo.ei') }}</span>
    </div>
    <div class="common_readonly_template">
      <el-row>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <!-- noa: '活动名称', -->
            <div class="label">{{ activityData.marketingForm === 1 ? $t('industryReport.hdxx.hdmc') : $t('industryReport.hdxx.yxzt') }}</div>
            <commonTooltip class="text" ref-name="activityDataActivityName" :content="activityData.activityName" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.businessUnit">
          <div>
            <!-- bu: '业务单元', -->
            <div class="label">{{ $t('industryReport.hdxx.ywdy') }}</div>
            <commonTooltip class="text" ref-name="activityDataBusinessUnit" :content="activityData.businessUnit" />
          </div>
        </el-col>
        <!-- 营销形式 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.yxxs') }}</div>
            <commonTooltip class="text" ref-name="activityDataMarketingFormName" :content="activityData.marketingFormName" />
          </div>
        </el-col>
        <el-col v-if="activityData.marketingForm === 1" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <!-- coa: '活动分类', -->
            <div class="label">{{ $t('industryReport.hdxx.hdfl') }}</div>
            <commonTooltip class="text" ref-name="activityDataActivityClassification" :content="activityData.activityClassification" />
          </div>
        </el-col>
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.relatedActivityName && activityData.relatedActivityCode && hdActiveValue">
          <div>
            <div class="label">{{ activityData.relationActivityName }}</div>
            <commonTooltip class="text" ref-name="activityDataRelatedActivityName" :content="hdActiveValue" />
          </div>
        </el-col>
        <el-col v-if="activityData.marketingForm === 1" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <!-- foa:活动形式 -->
            <div class="label">{{ $t('industryReport.hdxx.hdxs') }}</div>
            <commonTooltip class="text" ref-name="activityDataActivityForms" :content="activityData.activityForms" />
          </div>
        </el-col>
        <el-col v-if="activityData.marketingForm === 1" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <!-- Organizer：主办方 -->
            <div class="label">{{ $t('industryReport.hdxx.zbf') }}</div>
            <commonTooltip class="text" ref-name="activityDataOrganizer" :content="activityData.organizer" />
          </div>
        </el-col>
        <!-- 主要目标对象 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.zymbdx') }}</div>
            <commonTooltip class="text" ref-name="activityDataTargetObject" :content="formatTargetObject(activityData.targetObject, activityData.targetObjectOther)" />
          </div>
        </el-col>
        <!-- 目标夏盖客户画像 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.mbfgkhhx') }}</div>
            <commonTooltip class="text" ref-name="activityDataTargetCoverageCustomerPortrait" :content="activityData.targetCoverageCustomerPortrait" />
          </div>
        </el-col>
        <!-- 邀请方 -->
        <el-col v-if="activityData.marketingForm === 1" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.yqf') }}</div>
            <commonTooltip class="text" ref-name="activityDataInvitingPartyName" :content="activityData.invitingPartyName" />
          </div>
        </el-col>
        <!-- 品推支持 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.brandPromotionSupport">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ps') }}</div>
            <div class="text">{{ activityData.brandPromotionSupport }}</div>
          </div>
        </el-col>
        <!-- 举办城市 -->
        <el-col v-if="activityData.marketingForm === 1 && activityData.activityClassificationCode !== 'AC_01'" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.jbcs') }}</div>

            <commonTooltip class="text" ref-name="activityDataCity" :content="activityData.city" />
          </div>
        </el-col>
        <!-- 是否面向全国发布 -->
        <el-col v-if="activityData.marketingForm === 1" :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.mxqgfb') }}</div>

            <div class="text">{{ activityData.isNationalReleaseName }}</div>
          </div>
        </el-col>
        <!-- 关键市场 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.gjsc') }}</div>

            <commonTooltip class="text" ref-name="activityDataKeyMarket" :content="activityData.keyMarket" />
          </div>
        </el-col>
        <!-- 预计举办周期 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.yjjbzq') }}</div>
            <commonTooltip class="text" ref-name="activityDataExpectStartDate" :content="activityData.expectStartDate + ' 至 ' + activityData.reportExpectEndDate" />
          </div>
        </el-col>
        <!-- 活动工具包 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.marketingForm === 1 && activityData.activityToolkit">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.hdgjb') }}</div>
            <commonTooltip class="text" ref-name="activityDataActivityToolkit" :content="activityData.activityToolkit" />
          </div>
        </el-col>
        <!-- 面向行业 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8">
          <div>
            <div class="label">{{ $t('industryReport.hdxx.mxhy') }}</div>

            <div class="text">{{ activityData.targetIndustryName }}</div>
          </div>
        </el-col>
        <!-- 远程poc -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportRemotePoc">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.rp') }}</div>
            <div class="text">{{ activityData.reportRemotePoc }}</div>
          </div>
        </el-col>
        <!-- 联合精钻活动 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportUnitedDiamondActivity">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.jra') }}</div>
            <div class="text">{{ activityData.reportUnitedDiamondActivity }}</div>
          </div>
        </el-col>
        <!-- 圈子活动 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportCircleActivity">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ca') }}</div>
            <div class="text">{{ activityData.reportCircleActivity }}</div>
          </div>
        </el-col>
        <!-- 模板参观 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportTemplateVisit">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.mv') }}</div>
            <div class="text">{{ activityData.reportTemplateVisit }}</div>
          </div>
        </el-col>
        <!-- 样机演示/体验 -->
        <el-col :xs="12" :sm="12" :md="12" :lg="8" :xl="8" v-if="activityData.reportMachineDemo">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.machineDemo') }}</div>
            <div class="text">{{ activityData.reportMachineDemo }}</div>
          </div>
        </el-col>
        <!-- 活动内容涉及产品线 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactProductLineList && echoData.mactProductLineList.length > 0">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.artpl') }}</div>
            <div class="text">{{ activityData.productlineSupplement }}</div>
          </div>
        </el-col>
        <!-- 战略产品 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="echoData.mactCommunicationScenarioList && echoData.mactCommunicationScenarioList.length > 0 && lang === 'zh-CN'">
          <div>
            <div class="label">{{ comscValue }}</div>
            <div class="text">{{ activityData.communicationScenarioList }}</div>
          </div>
        </el-col>
        <!-- 活动背景&目的 -->
        <el-col :xs="24" :sm="24" :md="24" :lg="24" :xl="24" v-if="activityData.marketingForm === 1 && lang === 'zh-CN'">
          <div>
            <div class="label">{{ $t('newApp.activityInfo.ActivityBgA') }}</div>
            <div class="text">{{ activityData.activityBackgroundPurpose }}</div>
          </div>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
import commonTooltip from '@/components/commonTooltip';
import { isNotEmpty } from '../../../../../utils/utils';
import { newApplicationFormApi } from '@/views/newApplicationForm/service';
import { targetObjectDisplayMixin } from '@/views/newApplicationForm/mixins/targetObjectMixin';

export default {
  mixins: [targetObjectDisplayMixin],
  props: {
    echoData: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data () {
    return {
      activityData: {},
      lang: localStorage.getItem('lang') || 'zh-CN',
      comscValue: ''
    };
  },
  components: {
    commonTooltip
  },
  computed: {
    hdActiveValue () {
      let value = '';
      switch (this.activityData.activityClassificationCode) {
      case 'AC_03':
      case 'AC_06':
        value = this.activityData.hqActivityName;
        break;
      case 'AC_01':
        value = this.activityData.relatedActivityName;
        break;
      }
      return value;
    }
  },
  mounted () {
    // 活动信息数据源
    this.activityData = {
      ...this.echoData.marketActivityExpand,
      ...this.echoData.marketActivity
    };
    // 活动关联名称 由活动分类控制显示不同字段值
    switch (this.activityData.activityClassificationCode) {
      case 'AC_03':
      case 'AC_06':
        // home.ha 总部活动
        this.activityData.relationActivityName = this.$t('home.ha');
        break;
      case 'AC_01':
        // home.ta 模板活动
        this.activityData.relationActivityName = this.$t('newApp.activityInfo.ta');
        break;
    }
    // 原活动分层逻辑废弃，暂时注释掉
    // switch (this.activityData.activityLevel) {
    //   case 'A':
    //      this.activityData.activityLevelName = 'A类重点活动';
    //     break;
    //   case 'B':
    //     this.activityData.activityLevelName = 'B类小型会议';
    //     break;
    //   case 'C':
    //      this.activityData.activityLevelName = 'C类关系活动';
    //     break;
    //     case 'D':
    //      this.activityData.activityLevelName = 'D类数字营销';
    //     break;
    // }

    // 活动预计板块
    // if (this.echoData.mactModuleList && this.echoData.mactModuleList.length > 0) {
    //   this.activityData.mactModuleList = this.echoData.mactModuleList.map(item => {
    //     return item.moduleName;
    //   }).join('，');
    // }
    // 产品线 数据处理
    if (this.echoData.mactProductLineList && this.echoData.mactProductLineList.length > 0) {
      this.activityData.productlineSupplement = this.echoData.mactProductLineList.filter(item => item.reportType === 0).map(item => {
        if (item.productLineName.indexOf('其他') >= 0) {
          item.productLineName = item.customProductLine;
        }
        return item.productLineName;
      }).join('，');
    }
    // 营销形式数据处理
    // 营销形式（1-市场活动 2-数字营销（内容营销））
    if (this.echoData.marketActivityExpand.marketingForm) {
      this.activityData.marketingFormName = this.echoData.marketActivityExpand.marketingForm === 1 ? this.$t('industryReport.hybblb.cxtj.schd') : this.$t('industryReport.hybblb.cxtj.szyx');
    }
    if (this.echoData.marketActivityExpand.invitingParty) {
      this.activityData.invitingPartyName = this.echoData.marketActivityExpand.invitingParty === 2 ? this.$t('industryReport.hybblb.bxxq.hyzzyq') : this.$t('industryReport.hybblb.bxxq.qyyq');
    }
    // isNationalRelease: 1 是，0 否;
    this.activityData.isNationalReleaseName = this.echoData.marketActivity.isNationalRelease === 1 ? this.$t('btn.Yes') : this.$t('btn.No');
    // "targetIndustry": "",  // 面向行业（1-高职教 2-普教 3-医疗 4-企业 5-政府 6-AIGC 7-智能建筑及ICT）
    // if (this.echoData.marketActivityExpand.targetIndustry) {
    //   switch (this.echoData.marketActivityExpand.targetIndustry) {
    //     case 1:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.gzj');
    //       break;
    //     case 2:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.pj');
    //       break;
    //     case 3:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.yl');
    //       break;
    //     case 4:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.qy');
    //       break;
    //     case 5:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.zw');
    //       break;
    //     case 6:
    //       this.activityData.targetIndustryName = 'AIGC';
    //       break;
    //     case 7:
    //       this.activityData.targetIndustryName = this.$t('industryReport.hybblb.bxxq.znbj');
    //       break;
    //   }
    // }
    // 战略产品 数据处理
    if (isNotEmpty(this.echoData.mactCommunicationScenarioList)) {
      this.activityData.communicationScenarioList = this.echoData.mactCommunicationScenarioList.map(item => {
        return item.communicationScenarioName;
      }).join('，');
      let params = ['fb_communication_scenario'];
      newApplicationFormApi.getActivityList(params).then(res => {
        if (res.status === '200') {
          const list = res.data.fbCommunicationScenario.filter(item => item.flag);
          const index = list.findIndex(item => item.fieldKey === this.echoData.mactCommunicationScenarioList[0].communicationScenarioCode);
          if (index !== -1) {
            // 战略产品 展示名称
            this.comscValue = this.$t('newApp.activityInfo.strpr');
          } else {
            this.comscValue = this.$t('newApp.activityInfo.comsc');
          }
        }
      });
    }
    if (isNotEmpty(this.echoData.mactAgendaList)) {
      this.activityData.agendaList = this.echoData.mactAgendaList.map(item => {
        return item.agendaName;
      }).join('，');
    }
  }
};
</script>

<style scoped>

</style>
